<template>
    <div>
        <template v-if="settingStore.isDashboardBannerEnable == 1">
            <div v-html="settingStore.dashboardBanner"></div>
        </template>
        <div v-if="_.includes(billingStore.SUBSCRIPTION_STATUSES, userStore.user.subscription_status)" class="alert alert-warning" role="alert">
            <div class="alert-body">
                {{ localizationStore.translate("subscription.status." + userStore.user.subscription_status) }}
                <router-link
                    :to="{ name: 'billing-subscriptions-plan'}"
                    class="alert-link"
                >
                    Billing Portal
                </router-link>
            </div>
        </div>
        <div v-if="userStore.user.canAvailBlackFridaySale" class="alert alert-primary" role="alert">
            <div class="alert-body">
                UNLOCK HUGE SAVINGS! BLACK FRIDAY DEAL 🎁 3-Months Access!
                <a
                    href="#"
                    class="alert-link"
                    @click.stop.prevent="openModal('#sale-plans')"
                >
                    CLICK HERE
                </a>
            </div>
        </div>
        <div v-if="userStore.user.canAvailYearEndSale" class="alert alert-primary" role="alert">
            <div class="alert-body">
                UNLOCK HUGE SAVINGS! YEAR END DEAL 🎁 3-Months Access!
                <a
                    href="#"
                    class="alert-link"
                    @click.stop.prevent="openModal('#year-end-sale-modal')"
                >
                    CLICK HERE
                </a>
            </div>
        </div>
        <div class="row match-height">
            <welcome-component/>
            <credit-monitoring/>
            <div class="col-lg-4 col-12" id="credit_scores_step">
                <div class="card card-statistics">
                    <div class="card-header mx-auto">
                        <h3 class="card-title text-primary">Credit Scores</h3>
                    </div>
                    <div class="dashboardScore">
                        <credit-scores :email="userStore.user.email" />
                    </div>
                </div>
            </div>
            <!-- <dispute-count /> -->
        </div>
        <timeline-component></timeline-component>
        <div class="row">
            <update-personal-info></update-personal-info>
            <update-credit-report></update-credit-report>
            <!-- <congratulations-names></congratulations-names> -->
        </div>
        <dispute-letter-tracker />
        <personal-info-modal></personal-info-modal>
        <credit-monitoring-services-modal></credit-monitoring-services-modal>
        <credit-analysis-modal></credit-analysis-modal>
        <add-phone-component/>
        <fax-modal-component />
        <email v-bind:have-letter="true" />
        <ssn-modal />
        <template v-for=" (video,index) in videos" :key="index">
            <video-player-model :videoData="video">
                <template #video_title>
                    {{video.title}}
                </template>
                <template #video>
                    <span v-html="video.source"></span>
                </template>
            </video-player-model>
        </template>

    </div>
</template>
<script>
import {ref} from 'vue'
import CreditMonitoring from "../report/CreditMonitoring.vue"
import WelcomeComponent from "./DiyComponents/WelcomeComponent.vue"
import { useBillingStore } from '../../stores/BillingStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'
import TimelineComponent from '../user/TimelineComponent.vue'
import UpdatePersonalInfo from './DiyComponents/UpdatePersonalInfo.vue'
import UpdateCreditReport from './DiyComponents/UpdateCreditReport.vue'
import CongratulationsNames from './DiyComponents/CongratulationsNames.vue'
import PersonalInfoModal from './DiyComponents/PersonalInfo/PersonalInfoModal.vue'
import CreditMonitoringServicesModal from './DiyComponents/CreditMonitoringServices.vue'
import DisputeLetterTracker from '../dispute_letter/DisputeLetterTracker.vue'
import CreditAnalysisModal from "./DiyComponents/CreditAnalysisModal.vue"
import { loadTour } from "./Tours/dashboard_tour.js"
import { closeModal, openModal, hideModal } from '../../utilities/_helpers'

export default{
    components:{
        CreditMonitoring,
        TimelineComponent,
        UpdatePersonalInfo,
        UpdateCreditReport,
        CongratulationsNames,
        PersonalInfoModal,
        CreditMonitoringServicesModal,
        DisputeLetterTracker,
        CreditAnalysisModal,
        WelcomeComponent
    },
    props:{

    },
    setup(){
        return{
            billingStore: useBillingStore(),
            localizationStore: useLocalizationStore(),
            openModal,
            userStore: useUserStore(),
            videos:ref([
                {
                    id : "personal_info_modal_video",
                    title : "The Essential Guide to Uploading Your Proof Of Identity Documents",
                    type:"youtube",
                    source : "https://www.youtube.com/embed/qrX-o8qIatg"
                },
                {
                    id : "dispute_process_modal_video",
                    title : "Importing and Re-importing Your Credit Reports",
                    type:"youtube",
                    source : "https://www.youtube.com/embed/9aAkkFc0i28"
                },
                {
                    id : "dispute_letter_tracker_modal_video",
                    title : "Dispute Letter Video",
                    type:"youtube",
                    source : "https://www.youtube.com/embed/4-Rwmoc6mmQ"
                }
            ]),
            settingStore: useSettingStore(),
            loadTour:loadTour,
            _: _,
        }
    },
    beforeMount(){
        this.settingStore.tour_setup.step_name = 'diy_dashboard_tour';
    },
    watch: {
    },
    mounted() {
        this.userStore.fetchuserDashboard();
        this.userStore.fetchCheckValidUserDispute();
        this.loadTour(this.settingStore.tour_setup.step_name,false)
    },
    created(){
    },
    methods: {
        isMobileOrTablet() {
            const mobileAndTabletQuery = window.matchMedia('(max-width: 1200px)');
            return mobileAndTabletQuery.matches;
        },
    },

}
</script>
